import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';

@Component({
  selector: 'app-multimedia-image-preview',
  imports: [ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './multimedia-image-preview.component.html',
  styleUrl: './multimedia-image-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaImagePreviewComponent {
  public readonly alt = input.required<string>();
  public readonly previewUrl = input.required<string>();
  public readonly width = input.required<number>();
  public readonly height = input.required<number>();
}
